export const ANALYTICS_MODULES = [
  { id: "underlying", label: "Underlying" },
  { id: "optionLTP", label: "Option LTP" },
  { id: "pcr", label: "PCR Analysis" },
  { id: "builders", label: "Top Builders" }
];